import React, { Component } from 'react';
import $ from 'jquery';
import { Link} from 'react-router';
import {connect} from 'react-redux';
import {Breadcrumb} from 'react-bootstrap';
import * as actions from './../../actions';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
// import { Button} from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import Deal from './modules/Sead_deal_list.js';

// Path : /web/seed/:Name/:Dtype

const baseUrl='https://aquadeals.in/admin/web3/user/';
class Web_SeedsList extends Component {
  constructor(){
    super();
    this.state={
      seedsList: [],
      bread: '',
      web_title: '',
      web_desc: '',
      selected: '',
      loading: false,
      loadmore_status: 0,
      next_page: 0,
      seo_desc:'Browse best deals from various Hatcheries located in nearest Coasts.',
      deal_categories_list:[],
      cat_vannamei:'',
      cat_tiger:'',
      loading_gif:false,
      h1_desc:'',
      nodata_status:false,

      cats:[],
      sortlist:[],
      sortid:'',
      speciesid:'',
      total_deals:'',
    };
    this.getDeals=this.getDeals.bind(this);
    this.loadMoreDeals=this.loadMoreDeals.bind(this);
    localStorage.setItem('h_type','1');
    this.getDeviceId=this.getDeviceId.bind(this);
    this.getCategories=this.getCategories.bind(this);
    this.refresh=this.refresh.bind(this);
    this.fetchData=this.fetchData.bind(this);

    this.getSeedFilter =this.getSeedFilter.bind(this);
    this.getSelectedItem =this.getSelectedItem.bind(this);
  }
  getCategories()
  {
      
      var data1={from: 'desktop_web'};
      var data2=JSON.stringify(data1);
      $.ajax({
          method:'POST',
          url:baseUrl+'Getcategories',
          dataType:'json',
          data:{req:data2},
          success: function(data)
          {
            this.setState({
                deal_categories_list:data.deal_categories,
                cat_vannamei: data.deal_categories[0]['categories'][0]['title'],
                
                cats:data.deal_categories,
            });

            if(data.deal_categories[0]['categories'].length >= 2)
            {
              this.setState({
                cat_tiger:data.deal_categories[0]['categories'][1]['title'],
              });
            }
            else
            {
                this.setState({
                  cat_tiger:'',
                });
            }
          }.bind(this),
          error: function(err)
          {
          }
      });
  }
  getSeedFilter()
  {
     var data1 ={from:'desktop_web'};
     var data2=JSON.stringify(data1);
     $.ajax({
        url:baseUrl+'seedFilters',
        method:'POST',
        dataType:'JSON',
        data:{req:data2},
        success:function(data)
        {
            if(data)
            {  
              this.setState({
                   sortlist:data.sort,
              });
            }
        }.bind(this),
        error:function(err)
        {

        }
     });
  }
  getSelectedItem(event)
  {
     // var value = event.target.value;
     var index = event.target.selectedIndex;
     var optionElement = event.target.childNodes[index];
     var id =  optionElement.getAttribute('id'); 
     this.setState({sortid:id}); 

     var data1 ={from:'desktop_web',sort:id,species:this.props.params.Dtype}  
     var data2 =JSON.stringify(data1);
     $.ajax({
         url:baseUrl+'getdeals',
         method:'POST',
         dataType:'JSON',
         data:{req:data2},
         success:function(data)
         {
            this.setState({
                loading: true,
                seedsList:data.data,
                offer:data,
              });
         }.bind(this),
         error:function(err)
         {

         }  
     });    
  }
  getDeviceId()
  {
    if(localStorage.user_id)
    {
      var user_id=localStorage.user_id;
    }
    else
    {
      user_id=0;
    }
    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data)
        {
        },
        error: function(err)
        {
        }
    });
  }
  getDeals(type,name)
  {
      this.setState({
          loading_gif:true,
      });
      localStorage.setItem('w_r_seed_deals','/web/seed/'+name+"/"+type);
      $(window).scrollTop(0);
      if(this.state.sortid)
      {
        var sortid =this.state.sortid;
      }
      else
      {
         sortid =0;
      }

      var data1={from: 'desktop_web',species:type,sort:sortid};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getdeals',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
              this.setState({
                  seedsList:data.data,
                  offer: data,
                  loading:true,
                  web_title: data.title,
                  web_desc: data.desc,
                  loadmore_status:data.load_more,
                  next_page:data.next_page,
                  seo_title: data.title+' Aqua seed deals from Hatcheries',
                  seo_desc:'Browse quality '+data.title+' Aquaculture seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
                  loading_gif:false,
                  total_deals:data.total_records,
              });
              if(data.data.length <=0)
              {
                this.setState({
                  nodata_status:true,
                })
                window.location.href="/web/home";
              }
              else
              {
                this.setState({
                  nodata_status:false,
                })
              }
              this.setState({
                h1_desc:'Shop '+data.title+' Aqua seed deals from Hatcheries',
              })
              // document.title =this.state.web_title +  " - Deals | AquaDeals ";
              document.title =this.state.seo_title;
              document.getElementsByTagName("META")[2].content=this.state.seo_desc;
              if(data.status==='error' && data.message==='Token mismatch')
              {
                this.props.tokenCheck();
              }
          }.bind(this),
          error: function(err)
          {
            // console.log("Error"+err);
            this.setState({
                loading_gif:false,
            });
          }
     });
  }
  fetchData()
  {
    this.setState({
        loading_gif:true,
     })
    // this.props.params.Dtype,this.state.next_page,this.state.load_more_status
    var species=this.props.params.Dtype ? this.props.params.Dtype : '';
    var page =this.state.next_page;
    
    if(this.state.loadmore_status===1)
    {
        var data1={from:'desktop_web',species:species,page:page};
        var data2=JSON.stringify(data1);
        $.ajax({
              method: 'POST',
              url: baseUrl+'getdeals',
              dataType:'json',
              data: {req:data2},
              success: function(data)
              {
                  this.setState({
                    loading: true,
                    offer: data,
                    web_title: data.title,
                    web_desc: data.desc,
                    bread: data.title,
                    selected: data.title,
                    loadmore_status:data.load_more,
                    next_page:data.next_page,
                    loading_gif:false,

                    total_deals:data.total_records,
                });
                this.setState({ 
                    seedsList: this.state.seedsList.concat(data.data),
                });
                if(data.status==='error' && data.message==='Token mismatch')
                {
                  this.props.tokenCheck();
                }
              }.bind(this),
              error:function(err)
              {
                this.setState({
                  loading_gif:false,
                })
                // console.log(err);
              }
          });
    }
    else
    {
      this.setState({
        loading_gif:false,
      })
    }
  }
  refresh()
  {
    console.log("");
  }
  componentDidMount()
  {
    localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('profile');
    localStorage.removeItem('myaquacash');
    localStorage.removeItem('web_share_earn');
    localStorage.removeItem('checkout');
    localStorage.removeItem('order_details');
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
   
    localStorage.removeItem('nauplii');
    localStorage.removeItem('subdeals');
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');

    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
    localStorage.removeItem('offers');
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals')
    if(this.props.params.Name && this.props.params.Dtype && screen.width <= 800)
    {
      window.location.href="/seed/"+this.props.params.Name+"/"+this.props.params.Dtype;
    }
    else if (!this.props.params.Name && !this.props.params.Dtype && screen.width <= 800 ){
      window.location.href="/seed";
    }

    if(!localStorage.token && !localStorage.user_id && !this.props.params.Name && !this.props.params.Dtype)
    {
       localStorage.setItem('seed','/web/seed');
       localStorage.removeItem('w_r_seed_deals');
    }
    else if(!localStorage.token && !localStorage.user_id && this.props.params.Name && this.props.params.Dtype)
    {
       localStorage.setItem('w_r_seed_deals','/web/seed/'+this.props.params.Name+"/"+this.props.params.Dtype);
       localStorage.removeItem('seed');
    }


    this.getCategories();
    this.getDeviceId();
    // localStorage.setItem('w_r_seed_deals','/web/seed/'+this.props.params.Name+"/"+this.props.params.Dtype);
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('sprice');
    localStorage.removeItem('pprice');
    localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('w_r_p_deals');
  
    $(window).scrollTop(0);
    localStorage.setItem('h_type','1'); 
    var data1 = '';
    if(this.props.params.Name && this.props.params.Dtype)
    { 
      
      data1 = {from: 'desktop_web',species:this.props.params.Dtype}; 
    }
    else
    {
      data1={from: 'desktop_web'};
    }
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'getdeals',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
              this.setState({
                loading: true,
                seedsList:data.data,
                offer: data,
                web_title: data.title,
                web_desc: data.desc,
                bread: data.title,
                selected: data.title,
                loadmore_status:data.load_more,
                next_page:data.next_page,
                seo_title:"Vannamei,Tiger seed deals from Hatcheries",
                seo_desc:'Browse quality Vannamei,Tiger seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
                   
                total_deals:data.total_records, 
              });
              if(data.data.length <=0)
              {
                this.setState({
                  nodata_status:true,
                })
                window.location.href="/web/home";
              }
              else
              {
                this.setState({
                  nodata_status:false,
                })
              }
              if(!this.props.params.Name && !this.props.params.Dtype)
              {
                this.setState({
                  h1_desc:'Shop Vannamei,Tiger seed deals from Hatcheries',
                });
                document.title =this.state.seo_title;
                document.getElementsByTagName("META")[2].content=this.state.seo_desc;
              }
              else
              {
                this.setState({
                  h1_desc: 'Shop '+data.title+' Aqua seed deals from Hatcheries',
                });
                document.title =data.title + " Aqua Seed deals from Hatcheries";
                document.getElementsByTagName("META")[2].content='Browse quality '+data.title+' seed deals from CAA approved Hatcheries, shop online and avail free shipment.';
              } 
              if(data.status==='error' && data.message==='Token mismatch')
              {
                  this.props.tokenCheck();
              }    
          }.bind(this),
          error: function(err)
          {
          }
     });
    this.getSeedFilter();
  }
  loadMoreDeals(species,page,loadmore)
  {
     this.setState({
        loading_gif:true,
     })
     var data1={from:'desktop_web',species:species,page:page};
     var data2=JSON.stringify(data1);
     $.ajax({
          method: 'POST',
          url: baseUrl+'getdeals',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                loading: true,
                offer: data,
                web_title: data.title,
                web_desc: data.desc,
                bread: data.title,
                selected: data.title,
                loadmore_status:data.load_more,
                next_page:data.next_page,
                loading_gif:false,

                total_deals:data.total_records,
            });
            this.setState({ 
                seedsList: this.state.seedsList.concat(data.data),
            });
            if(data.status==='error' && data.message==='Token mismatch')
            {
              this.props.tokenCheck();
            }
          }.bind(this),
          error:function(err){
            // console.log(err);
          }
      });
  }
  setFilter(filter,id) 
  {
    this.setState({selected: filter,speciesid:id})
  }
  isActive(value)
  {
    return 'li '+((value===this.state.selected) ?'active':'');
  }

/******** *********/
/******** ********/
  
  render(){
     var cate = this.state.cats.map(function(data,index){
      if(data.id === '1')
      {
         return  data.categories.map(function(data1,index){
           return(
              <li key={index} className={this.isActive(data1.title)} onClick={this.setFilter.bind(this,data1.title,data1.id)}>
                 <Link to={'/web/'+data1.url_dtype_name+'/'+data1.url_name+'/'+data1.id} onClick={()=>{this.setState({selected: data1.title}); this.getDeals(data1.id,data1.title)}}>
                    {data1.title ? data1.title: ''}
                 </Link>
              </li>
             );
           }.bind(this));
      }   
     }.bind(this));

    var seedFilters = this.state.sortlist.map(function(item,index){
         return(
              <option key={item.id} value={item.type} id={item.id}>{item.type}</option>   
          );
    });

    var deals = this.state.seedsList.map((deal, index) => (<Deal key={deal.deals_data.id} data={deal} />));
    return(
    <div className="web_deals web_seedslist_page">        
   {this.state.loading ? 
        <div className="lgt_gry">
            <WebHeaderInner/>
            <div className="clr">&nbsp;</div>
            <div className="clr">&nbsp;</div>
            <div className="clr">&nbsp;</div>
            <section className="container pro_lst_cntnt">
             <div className="clr">&nbsp;</div>
             <h1 className="page_title">{this.state.h1_desc}</h1>
              <div className="container"> 
                <Breadcrumb className="webpdeals_breadcrmb">
                    <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>{this.state.web_title}</Breadcrumb.Item>
                </Breadcrumb>
              </div> 
              <div className="tot_pro">
                    <div className="row" style={{marginRight:'0 !important'}}>
                     {/*<!-- filters start --> */}
                     <div className="col-md-3 col-sm-3">
                        <div className="filtrs_blk">
                           <h3>Categories</h3>
                             <ul>
                              {cate}
                             </ul>
                        </div>
                     </div> 
                     <div className="pro_sec col-md-9 col-sm-9">
                       {/*  <!-- products section header start --> */}
                           <div className="pro_sec_hdr">
                             <h3>{this.state.web_title}<span>&nbsp;({this.state.total_deals} Items)</span></h3>
                              <div className="pro_slt_fltr">
                                <select onChange={this.getSelectedItem}>
                                  <option>Select</option>
                                  {seedFilters}
                                </select>
                            </div>
                           </div>
                           {/*  <!-- products section header end --> */}
                         {/* <!-- products blocks start --> */}
                          <div className="row itm_lst"> 
                              {this.state.loading_gif ? <i className="web_loading_gif"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading" /></i> : ''}
                                <InfiniteScroll
                                  pullDownToRefresh
                                  pullDownToRefreshContent={
                                    <h3 style={{textAlign: 'center'}}>&#8595;</h3>
                                  }
                                  releaseToRefreshContent={
                                    <h3 style={{textAlign: 'center'}}>&#8593;</h3>
                                  }
                                  refreshFunction={this.refresh}
                                  next={this.fetchData}
                                  hasMore={true}
                                  scrollThreshold={0.3}
                                  loader={<h4></h4>}
                                  endMessage={
                                    <p style={{textAlign: 'center'}}>
                                      <b></b>
                                    </p>
                                  }>
                                  {deals}
                              </InfiniteScroll>
                              {this.state.nodata_status ? <div className="seed_no_data">No Deals Available</div> : ''}
                          </div>
                    </div> 
               </div>
             </div>    
            </section>
            <div classNames="clr">&nbsp;</div>
            <WebFooter/>
         </div>: <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:20+'%'}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /> </div>}</div>
    );
  } 
}


function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata,
    formdata_log:state.auth.formdata_log,
  };
}

export default connect(mapStateToProps,actions)(Web_SeedsList);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Seed/Web_SeedsList.js
 **/